import React from 'react';
const BRAND_LOGOS = [{
  name: 'Aspen Laser',
  src: 'https://cdn.magicpatterns.com/uploads/6sJBBBVY5X5SwQxubyZT8d/aspen-laser-logo-tight.png',
  tone: 'light',
  width: 'w-[136px]'
}, {
  name: 'Multi Radiance Medical',
  src: 'https://cdn.magicpatterns.com/uploads/1uSvh2c4GvcPaou7cFZQiv/multi-radiance-logo-tight.png',
  tone: 'dark',
  width: 'w-[140px]'
}, {
  name: 'AWUSA',
  src: 'https://cdn.magicpatterns.com/uploads/vU7ymN9woCWqfMQ7Z1BUMg/awusa-acoustic-wave-logo-tight.png',
  tone: 'dark',
  label: 'AWUSA',
  width: 'w-[140px]'
}, {
  name: 'LumaNova',
  src: 'https://cdn.magicpatterns.com/uploads/cGAUHMWRd116qzuguyqeC6/lumanova-logo.svg',
  tone: 'dark',
  width: 'w-[140px]'
}, {
  name: 'TheraLight',
  src: 'https://cdn.magicpatterns.com/uploads/vttP1Sb7gikoGaFWY35ZNt/theralight-logo-tight.png',
  tone: 'light',
  width: 'w-[132px]'
}, {
  name: 'ThermoVision',
  src: 'https://cdn.magicpatterns.com/uploads/pwi9F6MQ1aEKhfXdZzRCNm/thermovision-myovision-logo.png',
  tone: 'light',
  label: 'ThermoVision',
  width: 'w-[140px]'
}, {
  name: 'WellVu',
  src: 'https://cdn.magicpatterns.com/uploads/qMimGwm5vM6HRxKcW7oosi/wellvu-logo.png',
  tone: 'light',
  width: 'w-[120px]'
}, {
  name: 'Hivamat',
  src: 'https://cdn.magicpatterns.com/uploads/vNnD1dHYLjEaEQqbPKyjtJ/hivamat-logo-tight.png',
  tone: 'dark',
  width: 'w-[132px]'
}, {
  name: 'Endopuls',
  src: 'https://cdn.magicpatterns.com/uploads/2VZTmXjs9iTkUtkfftmxFG/endopuls-enraf-logo.png',
  tone: 'light',
  label: 'Endopuls',
  width: 'w-[128px]'
}] as const;
export function ManufacturerStrip() {
  return <section className="manufacturer-strip w-full max-w-full overflow-x-hidden border-y border-slate-200 bg-slate-50/90" data-id="element-222" data-mp="3bvrawx9jnvub">
      <div className="manufacturer-strip__inner mx-auto w-full max-w-7xl box-border overflow-x-hidden px-5 py-7" data-id="element-223" data-mp="3gy051wy5l3y0">
        <p className="manufacturer-strip__heading mx-auto max-w-full whitespace-normal break-words px-2 text-center text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-charcoal/55" data-id="element-224" data-mp="3lsvzt4ury5et">
          <span className="manufacturer-strip__heading-mobile" data-id="element-225" data-mp="2r66xk4q7x97m">
            TRUSTED MODALITY BRANDS
          </span>
          <span className="manufacturer-strip__heading-desktop" data-id="element-226" data-mp="316hbjrk2uknu">
            CURATED TECHNOLOGIES FROM TRUSTED MODALITY BRANDS
          </span>
        </p>
        <ul className="manufacturer-strip__chips mx-auto mt-4 grid w-full grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:justify-center lg:grid lg:max-w-[1128px] lg:grid-cols-9 lg:gap-1.5" aria-label="Trusted modality brands" data-id="element-227" data-mp="3ew1asneg8zse">
          {BRAND_LOGOS.map(brand => {
          const isDark = brand.tone === 'dark';
          return <li key={brand.name} className={`flex min-w-0 w-full flex-col items-center justify-center rounded-xl border px-2 shadow-[0_2px_8px_-4px_rgba(26,27,75,0.28)] last:col-span-2 last:mx-auto last:w-1/2 sm:w-[112px] sm:last:col-auto sm:last:w-[112px] lg:w-auto lg:last:w-auto ${brand.label ? 'h-16 gap-1' : 'h-14'} ${isDark ? 'border-teal/30 bg-navy' : 'border-slate-200 bg-white'}`} data-id="element-228" data-mp="1ugzbmvlosy36">
                <img src={brand.src} alt={`${brand.name} logo`} className="max-h-[30px] max-w-[120px] object-contain" data-id="element-229" data-mp="3rfya0yzg79a3" />
                {brand.label && <span className={`text-[9px] font-bold uppercase tracking-[0.1em] ${isDark ? 'text-white/85' : 'text-navy/70'}`} data-id="element-230" data-mp="3mh55hw252sm2">
                    {brand.label}
                  </span>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}